<template>
  <div class="main-container" :data-testid="TEST_ID.FOOTER.ROOT">
    <div v-if="isCarouselMode" class="brands-carousel-wrapper">
      <el-carousel
        class="brands-carousel"
        height="60px"
        indicator-position="none"
        :autoplay="true"
        :interval="5000"
        arrow="never"
      >
        <el-carousel-item v-for="(slide, idx) in slides" :key="idx">
          <div class="carousel-slide-row">
            <div v-for="brand in slide" :key="brand.alt" class="footer-block__details-content footer-block-image center">
              <div class="footer-block__image-wrapper global-media-settings">
                <img :src="brand.src" :alt="brand.alt" loading="lazy" />
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div v-else class="brands">
      <div v-for="brand in brands" :key="brand.alt" class="footer-block__details-content footer-block-image center">
        <div class="footer-block__image-wrapper global-media-settings">
          <img :src="brand.src" :alt="brand.alt" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TEST_ID from '@/testIds.json'

  const MIN_LOGO_SLOT_WIDTH = 108
  const LOGO_GAP = 12

  export default {
    name: "DsFooter",
    data() {
      return {
        TEST_ID,
        isCarouselMode: false,
        containerWidth: 0,
        logosPerSlide: 1,
        slides: [],
        brands: [
          { src: require('@/images/vigia.jpg'), alt: 'Vigia' },
          { src: require('@/images/gestya.jpg'), alt: 'Gestya' },
          { src: require('@/images/viesa.jpg'), alt: 'Viesa' },
          { src: require('@/images/voryl.jpg'), alt: 'Voryl' },
          { src: require('@/images/coblow.jpg'), alt: 'Coblow' },
          { src: require('@/images/vitran.jpg'), alt: 'Vitran' }
        ]
      };
    },
    methods: {
      chunkArray(arr, size) {
        const chunks = []
        for (let i = 0; i < arr.length; i += size) {
          chunks.push(arr.slice(i, i + size))
        }
        return chunks
      },
      refreshSlides() {
        const totalLogos = this.brands.length
        const possiblePerRow = Math.max(1, Math.floor(this.containerWidth / (MIN_LOGO_SLOT_WIDTH + LOGO_GAP)))
        if (this.isCarouselMode) {
          // When in carousel mode, force exactly 3 images per slide (or fewer if not enough logos)
          this.logosPerSlide = Math.min(3, totalLogos)
        } else {
          this.logosPerSlide = Math.min(possiblePerRow, totalLogos)
        }
        this.slides = this.chunkArray(this.brands, this.logosPerSlide)
      },
      onResize() {
        this.containerWidth = this.$el ? this.$el.clientWidth : window.innerWidth
        const totalLogos = this.brands.length
        const requiredWidth = (totalLogos * MIN_LOGO_SLOT_WIDTH) + ((totalLogos - 1) * LOGO_GAP)
        this.isCarouselMode = this.containerWidth < requiredWidth
        this.refreshSlides()
      }
    },
    mounted() {
      this.onResize()
      window.addEventListener('resize', this.onResize)
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.onResize)
    }
  }
</script>
<!--
position: relative;
position: fixed bottom;
solid #ececec;
-->
<style scoped>
.main-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-self: stretch;
  flex: 1 0 auto;
  box-sizing: border-box;
}
.brands {
  position: relative;
  min-height: 1px;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  align-items: center;
  column-gap: 12px;
  row-gap: 20px;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  margin: 0;
  padding: 40px 0;
  background-color: rgba(255, 255, 255, 1);
  border-top: 1px solid #E2E2E2;
  box-sizing: border-box;
}

.brands-carousel-wrapper {
  width: 100%;
  padding: 24px 0;
  background-color: rgba(255, 255, 255, 1);
  border-top: 1px solid #E2E2E2;
  box-sizing: border-box;
}

.brands-carousel {
  width: 100%;
}

.footer-block__details-content {
  width: 100%;
  height: 100%;
}

.footer-block-image.center {
  display: flex;
  justify-content: center;
}

.footer-block__image-wrapper {
  width: 108px;
  max-width: 100%;
  box-sizing: border-box;
}

/* Grid (non-carrusel) logos */
.brands img {
  margin: auto;
  display: block;
  width: 100%;
  max-height: 40px;
  height: auto;
}

/* Carrusel: forzar tamaño fijo y centrar el logo sin escalar al 100% del slide */
.brands-carousel .footer-block__details-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.brands-carousel .footer-block__image-wrapper {
  width: 108px;
  max-width: 108px;
}
.brands-carousel img {
  display: block;
  width: auto;
  max-height: 40px;
  height: auto;
}

/* Row inside a carousel slide that can contain multiple logos */
.carousel-slide-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
}
</style>
<!--margin: 0px auto;
  padding: 0px 0;
  -->